import { sendChatMessage } from '../../services/api/chatApi';

/**
 * CrowChat Agent API Service
 * Uses the same backend API as BroChat
 */

export const crowChatApi = {
  /**
   * Send message to CrowChat agent
   * @param {string} message - Message text
   * @param {Array} images - Selected images
   * @param {Object} options - Options including conversationId, mode, etc
   * @returns {Promise<Object>} - Agent response
   */
  sendMessage: async (message, images = [], options = {}) => {
    try {
      const response = await sendChatMessage(message, images, options);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('[CrowChat] API Error:', error);
      return {
        success: false,
        error: error.message || 'Failed to send message',
      };
    }
  },

  /**
   * Get chat history (placeholder)
   */
  getHistory: async () => {
    return [];
  },

  /**
   * Clear chat history (placeholder)
   */
  clearHistory: async () => {
    return { success: true };
  },
};

export default crowChatApi;
